import { LoginGuestData } from '@/core/domain/user/models/loginGuest-response.model';
import { createAction, props } from '@ngrx/store';

export const saveUser = createAction(
    '[AUTH] save user',
    props<{ value: LoginGuestData }>(),
);

export const getUser = createAction('[AUTH] get user');

// export const updateReservation = createAction(
//     '[AUTH] update reservation',
//     props<{ value: any }>(),
// );

// export const clearReservation = createAction('[AUTH] clear reservation');
